import React, { useState, useEffect } from "react";
import {
  Modal,
  Descriptions,
  Image,
  Button,
  Input,
  Select,
  Form,
  message,
  Upload,
  Table,
  Spin,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { subItemHooks } from "../hooks";

const { Option } = Select;

const UserDetail = ({ visible, onClose, banner, onDelete, onUpdate }) => {
  const [editing, setEditing] = useState(false);
  const [form] = Form.useForm();
  const [imageBase64, setImageBase64] = useState(null);
  const [messageList, setMessageList] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchSolapiList = async (pageNum = 1, userId) => {
    setLoading(true);
    try {
      const response = await subItemHooks.solapiSendList({ page: pageNum, user_id: userId });
      const { data, total_count } = response.data;
      setMessageList(data);
      setTotal(total_count);
    } catch (error) {
      console.error("메시지 데이터를 불러오는 데 실패했습니다.", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && banner?.user_id) {
      fetchSolapiList(1, banner.user_id);
    }
  }, [visible, banner]);

  if (!banner) return null;

  const handleEdit = () => {
    setEditing(true);
    form.setFieldsValue({
      banner_link: banner.banner_link,
      banner_location: banner.banner_location,
    });
  };

  const handleCancelEdit = () => {
    setEditing(false);
    setImageBase64(null);
    form.resetFields();
  };

  const handleImageChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageBase64(e.target.result);
    };
    reader.readAsDataURL(file);
  };

  const columns = [
    {
      title: "템플릿",
      dataIndex: "template_id",
      key: "template_id",
    },
    {
      title: "메시지",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "전송시간",
      dataIndex: "created_at",
      key: "created_at",
    },
  ];

  return (
    <Modal
      title="유저 상세 정보"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {!editing ? (
        <>
          <Descriptions bordered column={2} size="middle">
            <Descriptions.Item label="이름"> {banner.user_name} </Descriptions.Item>
            <Descriptions.Item label="생년월일"> {banner.birth} </Descriptions.Item>
            <Descriptions.Item label="성별">
              {banner.gender === "1" ? "남성" : "여성"}
            </Descriptions.Item>
            <Descriptions.Item label="전화번호"> {banner.hp} </Descriptions.Item>
            <Descriptions.Item label="가입일자" span={2}> {banner.created_at} </Descriptions.Item>
            <Descriptions.Item label="아기정보" span={2}>
              {Array.isArray(banner.babies) && banner.babies.length > 0 ? (
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', padding: '4px' }}>이름</th>
                      <th style={{ textAlign: 'left', padding: '4px' }}>출산예정일</th>
                      <th style={{ textAlign: 'left', padding: '4px' }}>구분</th>
                    </tr>
                  </thead>
                  <tbody>
                    {banner.babies.map((baby, index) => (
                      <tr key={index}>
                        <td style={{ padding: '4px' }}>{baby.name}</td>
                        <td style={{ padding: '4px' }}>{baby.birth}</td>
                        <td style={{ padding: '4px' }}>{baby.type === 'TWIN' ? '쌍태아' : '단태아'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <span>아기 정보 없음</span>
              )}
            </Descriptions.Item>
          </Descriptions>

          <div style={{ marginTop: 30 }}>
            <h3>메시지 전송 내역</h3>
            <Table
              dataSource={messageList}
              columns={columns}
              rowKey="id"
              pagination={{
                current: page,
                total: total,
                pageSize: 10,
                onChange: (pageNum) => {
                  setPage(pageNum);
                  fetchSolapiList(pageNum, banner.user_id);
                },
              }}
              loading={loading}
            />
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical" initialValues={banner}>
          <Form.Item
            name="banner_link"
            label="배너 링크"
            rules={[{ required: true, message: "배너 링크를 입력해주세요!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="banner_location"
            label="배너 위치"
            rules={[{ required: true, message: "배너 위치를 선택해주세요!" }]}
          >
            <Select>
              <Option value="home">홈</Option>
              <Option value="group">꼬꼬무리스트</Option>
              <Option value="product">제품리스트</Option>
              <Option value="content">관심정보리스트</Option>
            </Select>
          </Form.Item>
          <Form.Item name="banner_position" label="배너 노출 순서">
            <Input type="number" />
          </Form.Item>
          <Form.Item label="이미지 업로드">
            <Upload
              beforeUpload={(file) => {
                handleImageChange(file);
                return false;
              }}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />}>이미지 선택</Button>
            </Upload>
            {imageBase64 && (
              <Image
                src={imageBase64}
                alt="업로드된 이미지"
                width={300}
                style={{ display: "block", marginTop: "10px" }}
              />
            )}
          </Form.Item>
          <div style={{ textAlign: "right", marginTop: "20px" }}>
            <Button onClick={handleCancelEdit}>취소</Button>
          </div>
        </Form>
      )}
    </Modal>
  );
};

export default UserDetail;
